/**
 * @description video list model
 * @date 2019-04-15
 * @author jy wang
 */
import React, { PureComponent } from 'react';
import { Pagination } from 'antd';
import { UnitLi } from './component/unit-li';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react/custom';
import moment from 'moment';
import toast from '@util/toast';
import tool from '@util/tool';
import StatusTab from '../../components/StatusTab';
import './index.scss';

@inject('store')
@observer
class VideoList extends React.Component<any, any> {
    public timer;

    public tabList =  [
        { status: null, text: '全部'},
         { status: 1, text: '审核中' },
         { status: 2, text: '已发布' },
         { status: 3, text: '审核未通过' },
         { status: 5, text: '定时发布中'}
    ];
    public tabListMap = {
        1: '审核中',
        2: '已发布',
        3: '审核未通过',
        5: '定时发布中'
    };
    public constructor(props) {
        super(props);
    }
    public componentWillMount() {
        this.props.store.hasLoginManage();
        this.getVideoList();
    }
    public tabChange = (e) => {
        const info: any = {};
        info.status = e;
        this.getVideoList(info);
    }
    public render() {
        const { store } = this.props;
        const { videoList } = store;
        return (
            <div className="video-list-box">
                            <StatusTab onChange={this.tabChange}  tabList={this.tabList}
                />
                <div className="question-video-list-box">
                    <ul hidden={videoList.results.length <= 0}>
                        {videoList.results.length > 0 &&
                            videoList.results.map((item, idx) => {
                                const {name: groupName= ''} = item.group || {};
                                const status  = item.status || '';
                                return (
                                    <li key={idx}>
                                        <UnitLi
                                            playTime={item.playTime}
                                            favourSum={item.favourSum}
                                            commentSum={item.commentSum}
                                            browseSum={item.browseSum}
                                            editCall={() => this.editPics(item)}
                                            delVideo={this.delVideo}
                                            mageUrls={item.imageUrls}
                                            surfacePlot={item.surfacePlot}
                                            title={item.title}
                                            answerSum={item.answerSum}
                                            groupName={groupName}
                                            collectSum={item.collectSum}
                                            releaseTime={moment(
                                                item.releaseTime
                                            ).format('YYYY-MM-DD HH:mm:ss')}
                                            statusName={this.tabListMap[status]}
                                            id={item.id}
                                            item={item}
                                        />
                                    </li>
                                );
                            })}
                    </ul>
                    <p
                        hidden={
                            videoList.dataStatus !== 'done' ||
                            (videoList.dataStatus === 'done' &&
                                videoList.results &&
                                videoList.results.length > 0)
                        }
                        className="no-data">
                        暂无数据
                    </p>
                    <p
                        hidden={videoList.dataStatus !== 'pending'}
                        className="no-data">
                        加载数据中...
                    </p>
                </div>
                <div className="page-box">
                    <Pagination
                        size="small"
                        onShowSizeChange={this.onShowSizeChange}
                        onChange={this.pageChange}
                        defaultCurrent={1}
                        defaultPageSize={videoList.pageSize}
                        total={videoList.totalCount}
                        showSizeChanger={true}
                        showQuickJumper={true}
                    />
                </div>
            </div>
        );
    }
    public editPics = (item) => {
        const {groupId= ''} = item.group || {};
        location.href = tool.getToDetailHref('/video/create', {id: item.id, groupId});

    };
    public pageChange = (current, size) => {
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getVideoList(info);
    };
    public onShowSizeChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getVideoList(info);
    };
    public getVideoList = (param?) => {
        clearInterval(this.timer);
        let info: any = {};
        info.pageNo = 1;
        info.pageSize = 10;
        info = Object.assign(info, param);
        this.props.store.videoList.get(info);
        this.timer = setInterval(() => {
            this.props.store.videoList.get(info);
        }, 15 * 1000);
    };
    public delVideo = (id) => {
        this.props.store.videoList
            .del(id)
            .then(() => {
                toast.error('删除成功');
                this.getVideoList();
            })
            .catch((err) => {
                toast.error('删除失败');
            });
    };
}
export default VideoList;
